// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hRmU","icon":"styles_icon__k24NZ"};